import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API = "https://eps.elkomprintama.com/";

const inp =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-400";
const lbl =
  "block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1";

const TYPE_OPTIONS = ["PT", "CV", "Other"];

function AddCustomerModal({ onClose, onAdded }) {
  const [typeChoice, setTypeChoice] = useState("PT");
  const [customType, setCustomType] = useState("");
  const [custName, setCustName] = useState("");
  const [custPhone, setCustPhone] = useState("");
  const [custAddr, setCustAddr] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!custName.trim()) {
      toast.warning("Customer name is required.");
      return;
    }

    const cust_type = typeChoice === "Other" ? customType.trim() : typeChoice;

    setSaving(true);
    try {
      await axios.post(
        `${API}post/api/customer`,
        {
          cust_type,
          cust_name: custName.trim(),
          cust_phone: custPhone.trim(),
          cust_addr: custAddr.trim(),
        },
        { withCredentials: true },
      );
      toast.success("Customer added!");
      onAdded();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Failed to add customer.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-base font-bold text-gray-800">
            Add New Customer
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold leading-none"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="px-6 py-5 space-y-4">
          {/* Type selection */}
          <div>
            <label className={lbl}>Type</label>
            <div className="flex gap-2">
              {TYPE_OPTIONS.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setTypeChoice(t)}
                  className={`px-4 py-1.5 rounded-lg text-sm font-semibold border transition ${
                    typeChoice === t
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "bg-white text-gray-600 border-gray-300 hover:border-indigo-400"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
            {typeChoice === "Other" && (
              <input
                className={`${inp} mt-2`}
                name="customtype" type="text"
                placeholder="Enter type (e.g. UD, Toko...)"
                value={customType}
                onChange={(e) => setCustomType(e.target.value)}
              />
            )}
          </div>

          {/* Customer name */}
          <div>
            <label className={lbl}>
              Customer Name <span className="text-red-400">*</span>
            </label>
            <input
              className={inp}
              name="custname" type="text"
              placeholder="e.g. Sejahtera Abadi"
              value={custName}
              onChange={(e) => setCustName(e.target.value)}
            />
          </div>

          {/* Contact number */}
          <div>
            <label className={lbl}>Contact No.</label>
            <input
              className={inp}
              name="custphone" type="text"
              placeholder="e.g. 021-12345678"
              value={custPhone}
              onChange={(e) => setCustPhone(e.target.value)}
            />
          </div>

          {/* Address */}
          <div>
            <label className={lbl}>Address</label>
            <textarea
              className={`${inp} resize-none`}
              rows={3}
              placeholder="Customer address"
              value={custAddr}
              onChange={(e) => setCustAddr(e.target.value)}
            />
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 border border-gray-300 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-5 py-2 rounded-lg text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60"
            >
              {saving ? "Saving..." : "Add Customer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCustomerModal;
